import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=3c4b112d&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=ts"
export * from "./MentionsLegales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b112d",
  null
  
)

export default component.exports